<template>
  <div class="footer-help">
    <div class="pos t0 header-box zi1">
      <header-df class="user-header g-center"></header-df>
    </div>
    <offline></offline>
    <div class="search-box">
      <div style="width:802px" class="flex aic jcc">
        <i-input v-model="keyword" placeholder="请输入问题关键字" @on-enter="searchEvent"></i-input>
        <div class="search-box-btn  flex aic jcc"  @click="searchEvent">
          <img :src="icon" alt="">搜答案
        </div>
      </div>
    </div>
    <div v-if="!search">
      <div style="width:100%;background-color: #f5fcff;" >
        <div class="text-box  g-center">
          <p class="text-box-title">常见自助服务</p>
          <p class="text-box-content">
            以下是在使用格灵云平台可能会碰到的疑问，如果还是不能解决您的问题请
          <span class="text-box-kf" @click="showModel">联系客服</span></p>
        </div>
      </div>
      <div class="content-box por zi0" >
        <div class="user-content flex ova g-center">
          <div class="user-left">
            <router-view name="left" />
          </div>
          <div class="user-right flex-1">
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <div v-if="search && !total" class=" no-search clearfix" >
      <div class="no-search-box por">
        <img src="@/assets/images/help/sigh.png" class="no-search-box-img poa" alt="">
        <p class="no-search-box-title fs16">抱歉，没有找到相关帮助内容</p>
        <div>
          <p>我们建议您:</p>
          <p>1.<span class="no-search-box-link csp" @click="showModel">联系客服</span>。</p>
          <p>2.请检查您的输入是否有误。</p>
          <p>3.更换其他关键词重新搜索。</p>
        </div>
      </div>
    </div>
    <div v-if="search && total" style="background-color: #f5fcff;">
      <div class="g-center">
        <div class="result">
          <p class="result-p">共找到{{total}}条结果</p>
          <div class="result-item csp" v-for="(e,i) in result" :key="i" @click="toCore(e.id)">
            <div class="result-item-title" v-html="handleKeyword(e.title,keyword)"></div>
            <div class="result-item-content" v-html="handleKeyword(e.content_text,keyword)"></div>
          </div>
          <div class="result-page" v-show="total">
            <!-- <Page total="total" show-elevator @on-change="pageChange" /> -->
            <df-page :total="total" :current="curr" @on-change="pageChange"></df-page>
          </div>
        </div>
      </div>
    </div>
    <footer-bottom class="footer"></footer-bottom>
  </div>
</template>

<script>
import Mixins from '@/mixins/mixins'
export default {
  name: "HelpIndex",
  mixins: [Mixins.MakeRoute(['id'],)],
  data () {
    return {
      search: false,
      keyword: '',
      total: 0,
      curr: 1,
      result: [],
      icon: require('../../assets/images/help/search.png'),
    }
  },
  methods: {
    showModel () {
      this.$popup({})
    },
    handleKeyword (val, keyword) {
      if (keyword.length > 0) {
        let keywordArr = keyword.trim().split('').filter(v => v !== ' ');
        val = val + "";
        keywordArr.forEach(item => {
          if (val.indexOf(item) !== 0 && item !== "") {
            val = val.replace(
              new RegExp(item, 'g'),
              '<font color="#1177FF">' + item + "</font>"
            );
          }
        });
        return val;
      } else {
        return val;
      }
    },
    searchEvent () {
      let { keyword } = this;
      if (!keyword) {
        this.search = false;
        return
      }
      this.search = keyword !== '';
      this.http.NEWGetSearchList({ keyword, curr: this.curr }).then(res => {
        this.total = res.total;
        this.result = res.list;
      }).catch(this.$err);
    },
    toCore (id) {
      this.id = id;
      this.search = false;
    },
    pageChange (curr) {
      this.curr = curr;
      this.searchEvent();
    },
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/less/function';

/deep/ .mine-ico {
  &.img {
    .spirit(url(../../assets/images/user_icons.png));
  }
  &:not(.img) {
    .spirit-mask(url(../../assets/images/user_icons.png));
  }
  &:after {
    margin-right: 16px;
    width: 22px;
    height: 22px;
    background-color: #959595;
  }
  &.is-vip {
    &:after {
      width: 24px;
      height: 23px;
      mask-position: -50px -2px;
      background-color: #ffc264;
    }
  }
  &.checkbox-df {
    &:after {
      margin: 0;
      width: 19px;
      height: 19px;
      mask-position: -77px -3px;
      background-color: #fff;
    }
  }
  &.checkbox-check {
    &:after {
      margin: 0;
      width: 19px;
      height: 19px;
      mask-position: -99px -3px;
      background-color: #fff;
    }
  }
  &.hover-play {
    &:after {
      margin-right: 0;
      width: 44.3px;
      height: 44.3px;
      mask-position: -52px -30px;
      background-color: #fff;
    }
  }
  &.hover-delete {
    &:after {
      margin-right: 0;
      width: 24px;
      height: 24px;
      background-position: -121px -1px;
    }
  }
  &.lost-time {
    &:after {
      margin-right: 0;
      width: 58px;
      height: 58px;
      background-position: -102px -28px;
    }
  }
  &.tv {
    &:after {
      margin-right: 0;
      width: 104px;
      height: 85px;
      background-position: -229px -2px;
    }
  }
  &.no-follow {
    &:after {
      margin-right: 0;
      width: 104px;
      height: 85px;
      background-position: -340px -2px;
    }
  }
  &.audio {
    &:after {
      margin-right: 0;
      width: 25px;
      height: 25px;
      background-position: -146px -1px;
    }
  }
  &.play {
    &:after {
      mask-position: -3px -2px;
    }
  }
  &.hart {
    &:after {
      margin-right: 0;
      width: 14px;
      height: 14px;
      mask-position: -193.9px -3px;
      background-color: #999;
    }
  }
  &.collection {
    &:after {
      mask-position: -3px -26px;
    }
  }
  &.follow {
    &:after {
      mask-position: -3px -50px;
    }
  }
  &.course {
    &:after {
      mask-position: -3px -74px;
    }
  }
  &.vip {
    &:after {
      mask-position: -3px -98px;
    }
  }
  &.setting {
    &:after {
      mask-position: -3px -122px;
    }
  }
  &.edit-more {
    &:after {
      margin-right: 8px;
      width: 18px;
      height: 18px;
      mask-position: -173px -3px;
    }
  }
}

.header-box {
  background-color: #fff;
}

.content-box {
  padding-bottom: 48px;
  background-color: #f5fcff;
}

.user-left {
  margin-right: 16px;
}

.user-right {
  background-color: #fff;
}

.search-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 140px;
  background-color: #fff;
  /deep/ .ivu-input-wrapper {
    width: 680px !important;
  }
  /deep/ .ivu-input {
    width: 680px;
    height: 50px;
    border: 1px solid #1177ff;
    border-radius: 4px 0px 0px 4px;
    padding-left: 24px;
    background: #ffffff;
  }
  .search-box-btn {
    width: 120px;
    height: 50px;
    color: #fff;
    font-size: 18px;
    background-color: #1177ff;
    border: 1px solid #1177ff;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    &:hover {
      cursor: pointer;
      background-color: #0066ed;
    }
    img {
      margin-right: 9px;
    }
  }
}
.text-box {
  padding-top: 32px;
  // width: 100%;
  height: 119px;

  .text-box-title {
    font-size: 18px;
    color: #3a3a3a;
  }
  .text-box-content {
    color: #999fa6;
    margin-top: 15px;
  }
  .text-box-kf {
    color: #1177ff;
    text-decoration: underline;
    &:hover {
      cursor: pointer;
    }
  }
}
.result-p {
  padding-top: 30px;
  margin-bottom: 16px;
}
.result-item {
  width: 100%;
  // height: 118px;
  padding: 24px;
  background-color: #fff;
  margin-bottom: 16px;
  .result-item-title {
    font-size: 16px;
    color: #333f4e;
    margin-bottom: 16px;
  }
  .result-item-content {
    color: #999fa6;
  }
}
.result-page {
  text-align: center;
  margin-top: 32px;
  padding-bottom: 48px;
}
.no-search {
  width: 100%;
  height: 662px;
  background: #f5fcff;
  .no-search-box {
    width: 275px;
    height: 114px;
    padding-left: 67px;
    margin: 200px auto;
    .no-search-box-title {
      margin-bottom: 9px;
      color: #333f4e;
    }
    .no-search-box-img {
      width: 43px;
      height: 43px;
      top: 0;
      left: 0;
    }
    .no-search-box-link {
      color: #1177ff;
      text-decoration: underline;
    }
  }
}

.h100 {
  height: 100px;
}
</style>